import { EditOutlined, FieldTimeOutlined, MessageOutlined, SwapOutlined } from '@ant-design/icons';
import { Card, Col, Row } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Mesma ordem de buildAgreements(): o Figma lê em linhas (Envie | Distribua, Receba | Automatize).
const ICONS = [EditOutlined, SwapOutlined, MessageOutlined, FieldTimeOutlined];

export default function WelcomeScreen({ agreements }) {
	return (
		<div className="welcome-screen">
			<header className="onboarding-screen-header">
				<h1>
					<FormattedMessage id="welcome_title" />
				</h1>
				<p>
					<FormattedMessage id="welcome_subtitle" />
				</p>
			</header>

			<Row gutter={[24, 24]} className="welcome-screen-grid">
				{agreements.map((agree, index) => {
					const CardIcon = ICONS[index];
					return (
						<Col span={12} key={agree.title}>
							<Card bordered className="welcome-screen-card" bodyStyle={{ padding: 0 }}>
								<CardIcon className="welcome-screen-icon" />
								<div className="welcome-screen-card-copy">
									<div className="welcome-screen-card-title">{agree.title}</div>
									<div className="welcome-screen-card-description">{agree.description}</div>
								</div>
							</Card>
						</Col>
					);
				})}
			</Row>
		</div>
	);
}
